// src/Quiz.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'katex/dist/katex.min.css';
import { InlineMath } from 'react-katex';

function Quiz({ onComplete }) {
  const [question, setQuestion] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [score, setScore] = useState(0);
  const [questionCount, setQuestionCount] = useState(0);

  const fetchQuestion = async () => {
    try {
      setLoading(true);
      const response = await axios.get('https://topicquizzes.netlify.app/.netlify/functions/getQuestions');
      setQuestion(response.data);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching question:', err);
      setError('Failed to load question. Please try again.');
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQuestion();
  }, []);

  const handleAnswer = (selectedAnswer) => {
    if (selectedAnswer === question.correctAnswer) {
      setScore(score + 1);
    }
    setQuestionCount(questionCount + 1);

    if (questionCount < 9) {  // Assuming we want a 10-question quiz
      fetchQuestion();
    } else {
      onComplete(score + (selectedAnswer === question.correctAnswer ? 1 : 0), 10);
    }
  };

  if (loading) return <div>Loading question...</div>;
  if (error) return <div>{error}</div>;
  if (!question) return <div>No question available.</div>;

  return (
    <div className="quiz-container">
      <h2>Question {questionCount + 1} of 10</h2>
      <p>{question.questionText}</p>
      {question.latex && (
        <div className="latex-container">
          <InlineMath>{question.latex}</InlineMath>
        </div>
      )}
      <div className="options-container">
        {question.options.map((option, index) => (
          <button key={index} onClick={() => handleAnswer(option)}>
            {option}
          </button>
        ))}
      </div>
    </div>
  );
}

export default Quiz;